import { forwardRef, type Ref, type SVGProps } from "react";

function SvgTiersShiftLimited(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={124}
      height={109}
      fill="none"
      {...props}
    >
      <path
        stroke="url(#tiersShiftLimited_svg__a)"
        strokeWidth={10}
        d="M40.286 43.333v-16C40.286 15.551 50.007 6 62 6s21.714 9.551 21.714 21.333V32.5M34.857 102h54.286C95.139 102 100 97.224 100 91.333V54c0-5.891-4.86-10.667-10.857-10.667H34.857C28.861 43.333 24 48.11 24 54v37.333C24 97.224 28.86 102 34.857 102Z"
      />
      <path stroke="#0C1C43" strokeLinecap="round" d="M62 63v14" />
      <path
        fill="#82090F"
        d="m3.145 8.502 10.63-5.848a1.24 1.24 0 0 1 1.2 0l10.63 5.848a1.244 1.244 0 0 1 .425 1.796L15.398 25.713a1.244 1.244 0 0 1-2.046 0L2.72 10.298a1.244 1.244 0 0 1 .425-1.796"
      />
      <defs>
        <linearGradient
          id="tiersShiftLimited_svg__a"
          x1={62}
          x2={62}
          y1={6}
          y2={102}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FCBDC1" />
          <stop offset={1} stopColor="#F6F3F1" />
        </linearGradient>
      </defs>
    </svg>
  );
}
const ForwardRef = forwardRef(SvgTiersShiftLimited);
export default ForwardRef;
